module.exports = __webpack_public_path__ + "static/media/check-icon.908a366a.svg";